import { humaniseEnumKey } from "@/lib/enumLabel";

/**
 * Display labels for the recurring-fee keys the compensation editor writes.
 *
 * One map for every surface that shows an org's fees — the signed-in Value
 * tab and the anonymous public profile — so "eo_insurance" never reaches a
 * reader as a raw key on one page while it reads "E&O Insurance Fee" on
 * another. Both the `*_fee` and the bare spellings older write paths used
 * are mapped.
 */
export const FEE_TYPE_LABELS: Record<string, string> = {
  monthly_desk: "Monthly Desk Fee",
  transaction_fee: "Transaction Fee",
  transaction: "Transaction Fee",
  eo_insurance: "E&O Insurance Fee",
  technology_fee: "Technology / Software Fee",
  technology: "Technology / Software Fee",
  marketing_fee: "Marketing Fee",
  franchise_fee: "Franchise Fee",
  franchise: "Franchise Fee",
  training_fee: "Training Fee",
  mls_dues: "MLS / Board Dues",
};

/** Never drop an unmapped key — humanise it so the value still shows. */
export const feeTypeLabel = (key: string): string => FEE_TYPE_LABELS[key] || humaniseEnumKey(key);

export const feeTypeLabels = (keys: string[]): string[] => keys.map(feeTypeLabel);
